import type { ValueRange } from '~~/types/ValueRange';
import type { ProductListingPriceRange } from '~~/types/productListing/ProductListingFilterState';

// Like InstantSearch's connectRange: a bound left at the edge of the available range is unspecified,
// so changing only the upper bound doesn't also pin the lower one.
export const omitPriceBoundsAtRangeEdges = (
  { range, bounds }: { range: ValueRange; bounds: ValueRange | null },
): ProductListingPriceRange | undefined => {

  const min = range.min === bounds?.min ? undefined : range.min;
  const max = range.max === bounds?.max ? undefined : range.max;

  if (min === undefined && max === undefined) {

    return undefined;

  }

  return {
    ...(min !== undefined && { min }),
    ...(max !== undefined && { max }),
  };

};
